import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { MenuSeparator } from "../../../menu";
var shouldForwardProp = function shouldForwardProp(propName) {
  switch (propName) {
    case "optionHeight":
    case "shouldVirtualize":
    case "top":
      // Just add any extra props here :)
      return false;
  }
  return true;
};
export var VirtualizedSeparatorStyled = styled(MenuSeparator, {
  shouldForwardProp: shouldForwardProp
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref) {
  var shouldVirtualize = _ref.shouldVirtualize,
    optionHeight = _ref.optionHeight,
    top = _ref.top;
  return shouldVirtualize ? "\n                ".concat(top ? "top: ".concat(+top - optionHeight, "px") : "", ";\n                transform: translate(0, ").concat(optionHeight, "px);\n                position: absolute;\n                width: calc(100% - 32px);\n              ") : "";
});
//# sourceMappingURL=VirtualizedSeparatorStyled.js.map